import React, { useEffect, useState } from "react";
import { Row, Col, Form, Select } from "antd";

const { Option } = Select;

const ALL = "__ALL__";

const BranchLocationMultipleSelector = ({
    loginPlaceId,
    districtData,
    districtName,
    divisionalId,
    onChange
}) => {

    const [selectedDistrict, setSelectedDistrict] = useState([]);
    const [selectedDivisional, setSelectedDivisional] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState([]);

    const [availableDivisionals, setAvailableDivisionals] = useState([]);
    const [availableBranches, setAvailableBranches] = useState([]);

    /* -----------------------------
       LOGIN LOCK: District (4)
    ------------------------------*/
    useEffect(() => {
        if (loginPlaceId === "4" && districtName) {
            const district = districtData.find(
                d => d.districtName === districtName
            );
            if (district) setSelectedDistrict([district.districtId]);
        }
    }, [loginPlaceId, districtName, districtData]);

    /* -----------------------------
       District → Divisional
    ------------------------------*/
    useEffect(() => {
        let filtered = [];

        if (loginPlaceId === "2" && divisionalId) {
            filtered = districtData
                .flatMap(d => d.divisionalAreaDtoList || [])
                .filter(div => div.divAId === divisionalId);

            setSelectedDivisional([divisionalId]);
        } else {
            filtered = districtData
                .filter(d => selectedDistrict.includes(d.districtId))
                .flatMap(d => d.divisionalAreaDtoList || []);
        }

        setAvailableDivisionals(filtered);
        setSelectedBranch([]); // reset branch when parent changes

    }, [selectedDistrict, districtData, loginPlaceId, divisionalId]);

    /* -----------------------------
       Divisional → Branch
    ------------------------------*/
    useEffect(() => {
        if (!selectedDivisional.length) {
            setAvailableBranches([]);
            setSelectedBranch([]);
            return;
        }

        const filtered = availableDivisionals
            .filter(d => selectedDivisional.includes(d.divAId))
            .flatMap(d => d.branchDtoList || []);

        setAvailableBranches(filtered);

    }, [selectedDivisional, availableDivisionals]);

    /* -----------------------------
       Send to parent
    ------------------------------*/
    useEffect(() => {
        if (!onChange) return;

        const branchNames = availableBranches
            .filter(b => selectedBranch.includes(b.id))
            .map(b => b.branchName);

        onChange({
            districtIds: selectedDistrict,
            divisionalIds: selectedDivisional,
            branchIds: selectedBranch,
            branchNames
        });

    }, [selectedDistrict, selectedDivisional, selectedBranch, availableBranches]);

    /* -----------------------------
       SELECT ALL HANDLERS
    ------------------------------*/

    const handleDistrictChange = (values) => {
        const allIds = districtData.map(d => d.districtId);

        if (values.includes(ALL)) {
            const isAllSelected = selectedDistrict.length === allIds.length;
            setSelectedDistrict(isAllSelected ? [] : allIds);
            return;
        }

        setSelectedDistrict(values);
    };


    const handleDivisionalChange = (values) => {
        const allIds = availableDivisionals.map(d => d.divAId);

        if (values.includes(ALL)) {
            const isAllSelected = selectedDivisional.length === allIds.length;
            setSelectedDivisional(isAllSelected ? [] : allIds);
            return;
        }

        setSelectedDivisional(values);
    };


    const handleBranchChange = (values) => {
        const allIds = availableBranches.map(b => b.id);

        if (values.includes(ALL)) {
            const isAllSelected = selectedBranch.length === allIds.length;
            setSelectedBranch(isAllSelected ? [] : allIds);
            return;
        }

        setSelectedBranch(values);
    };

    const isAllSelected = (selected, all) =>
        selected.length === all.length &&
        all.every(id => selected.includes(id));

    const allDistrictIds = districtData.map(d => d.districtId);
    const districtAllSelected = isAllSelected(selectedDistrict, allDistrictIds);

    const allDivisionalIds = availableDivisionals.map(d => d.divAId);
    const divisionalAllSelected = isAllSelected(selectedDivisional, allDivisionalIds);

    const allBranchIds = availableBranches.map(b => b.id);
    const branchAllSelected = isAllSelected(selectedBranch, allBranchIds);





    return (
        <Row gutter={[16, 16]}>

            {/* District */}
            {(loginPlaceId === "3" || loginPlaceId === "4") && (
                <Col span={24}>
                    <Form.Item label="District">
                        <Select
                            mode="multiple"
                            value={selectedDistrict}
                            onChange={handleDistrictChange}
                            disabled={loginPlaceId === "4"}
                            allowClear
                            showSearch
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                            maxTagCount="responsive"
                            placeholder="Select District"
                        >
                            <Option value={ALL}>
                                {districtAllSelected ? "❌ Clear All" : "✅ Select All"}</Option>
                            {districtData.map(d => (
                                <Option key={d.districtId} value={d.districtId}>
                                    🏙️ {d.districtName}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            )}

            {/* Divisional */}
            {(loginPlaceId === "3" || loginPlaceId === "4" || loginPlaceId === "2") && (
                <Col span={24}>
                    <Form.Item label="Divisional Area">
                        <Select
                            mode="multiple"
                            value={selectedDivisional}
                            onChange={handleDivisionalChange}
                            disabled={loginPlaceId === "2"}
                            allowClear
                            showSearch
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                            maxTagCount="responsive"
                            placeholder="Select Divisional"
                        >
                            <Option value={ALL}>
                                {divisionalAllSelected ? "❌ Clear All" : "✅ Select All"}
                            </Option>
                            {availableDivisionals.map(d => (
                                <Option key={d.divAId} value={d.divAId}>
                                    🏘️ {d.divAIdName}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            )}

            {/* Branch */}
            {(loginPlaceId === "3" || loginPlaceId === "4" || loginPlaceId === "2") && (
                <Col span={24}>
                    <Form.Item label="Branch">
                        <Select
                            mode="multiple"
                            value={selectedBranch}
                            onChange={handleBranchChange}
                            allowClear
                            showSearch
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                            maxTagCount="responsive"
                            placeholder="Select Branch"
                            disabled={!availableBranches.length}
                        >
                            <Option value={ALL}>
                                {branchAllSelected ? "❌ Clear All" : "✅ Select All"}
                            </Option>
                            {availableBranches.map(b => (
                                <Option key={b.id} value={b.id}>
                                    🏢 {b.branchName}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            )}

        </Row>
    );
};

export default BranchLocationMultipleSelector;
